import React from "react";
import useWidth from "../hooks/useWidth";
import MobileHeader from "../layout/MobileHeader";
import OfferCard from "../components/cards/OfferCard";
import Navbar from "../layout/Navbar";
import HomeSearch from "../components/elements/HomeSearch";
import MobileHeaderSearch from "../components/MobileHeaderSearch";

const OffersPage = () => {
  const width = useWidth();
  return (
    <>
      {width > 992 ? (
        <>
        <Navbar gradient={true}/>
          <section className=" px-5 mt-5 pt-5">


          <div className="d-flex justify-content-center flex-column align-items-center guide-page-title ">
                <p className="custom-text-color xx-bold text-center  fs-1 ">
                  Search Results
                </p>
                <HomeSearch placeholder={"Local Guide"} />
              </div>
            {/* tailored offers */}
            <div className="offers mt-5  px-3 ">
              <div className="top-heading " style={{paddingLeft:"12%"}}>Offers Tailored For You</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

              </div>
            </div>

            {/* payments offers */}

            <div className="offers mt-5 pt-5 px-3">
              <div className="top-heading" style={{paddingLeft:"12%"}}>Payments Offers</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>

            {/* family offers */}
            <div className="offers mt-5  px-3">
              <div className="top-heading" style={{paddingLeft:"12%"}}>Family Offers</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>

            {/* Referrals */}

            <div className="offers mt-5  px-3">
              <div className="top-heading" style={{paddingLeft:"12%"}}>Referrals</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          <MobileHeader  height="237px" gradient={true}>
            <MobileHeaderSearch text={true} headingtext="Offers" />
          </MobileHeader>
          <section className="mobile-top-space ">
            {/* tailored offers */}
            <div className="offers mt-5 pt-5 px-3">
              <div className="top-heading">Offers Tailored For You</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>

            {/* payments offers */}

            <div className="offers mt-5  px-3">
              <div className="top-heading">Payments Offers</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>

            {/* family offers */}
            <div className="offers mt-5  px-3">
              <div className="top-heading">Family Offers</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>

            {/* Referrals */}

            <div className="offers mt-5  px-3">
              <div className="top-heading">Referrals</div>

              <div className="row  mx-0 my-3 ">
                <ul className="list-unstyled d-flex offers-card-list-mobile m-0  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default OffersPage;
